import $ from 'jquery';

  var FIELD_WRAPPER = '.populate-practice-treatments';
  var SELECT_IN_WRAPPER = FIELD_WRAPPER + ' select, ' + FIELD_WRAPPER + ' .gfield_select';

  // per-form guard to avoid dupes
  var pushed = {};

  function getFormId($form){
    var d = $form.data('formid');
    if (d) return parseInt(d, 10);
    var m = ($form.attr('id') || '').match(/^gform_(\d+)$/);
    return m ? parseInt(m[1], 10) : null;
  }

  function setFlag(fid){
    try { sessionStorage.setItem('gf_' + fid + '_has_treatment_field', '1'); } catch(e){}
  }
  function hadField(fid){
    try { return sessionStorage.getItem('gf_' + fid + '_has_treatment_field') === '1'; } catch(e){ return false; }
  }
  function stash(fid, val){
    try {
      sessionStorage.setItem('gf_' + fid + '_selected_treatment', val || '');
      setFlag(fid);
    } catch(e){}
  }
  function readAndClear(fid){
    var out = { selected_treatment: '' };
    try {
      out.selected_treatment = sessionStorage.getItem('gf_' + fid + '_selected_treatment') || '';
      sessionStorage.removeItem('gf_' + fid + '_selected_treatment');
      sessionStorage.removeItem('gf_' + fid + '_has_treatment_field');
    } catch(e){}
    return out;
  }

  // cache on change inside the wrapper
  $(document).on('change', 'form[id^="gform_"] ' + SELECT_IN_WRAPPER, function(){
    var $form = $(this).closest('form[id^="gform_"]');
    var fid = getFormId($form);
    if (!fid) return;
    stash(fid, $(this).val() || '');
  });

  // cache on submit button click (covers default/no-change)
  $(document).on('click', '[id^="gform_submit_button_"]', function(){
    var $form = $(this).closest('form[id^="gform_"]');
    var fid = getFormId($form);
    if (!fid) return;
    var $sel = $form.find(SELECT_IN_WRAPPER).first();
    if ($sel.length) stash(fid, $sel.val() || '');
  });

  // cache on form submit (Enter key)
  $(document).on('submit', 'form[id^="gform_"]', function(){
    var $form = $(this);
    var fid = getFormId($form);
    if (!fid) return;
    var $sel = $form.find(SELECT_IN_WRAPPER).first();
    if ($sel.length) stash(fid, $sel.val() || '');
  });

  // ensure exactly one handler; always emit event (all forms),
  // but only add selected_treatment if wrapper existed
  $(document).off('gform_confirmation_loaded.gfDL');
  $(document).on('gform_confirmation_loaded.gfDL', function(event, formId){
    if (pushed[formId]) return;
    pushed[formId] = true;

    window.dataLayer = window.dataLayer || [];
    var payload = {
      event: 'g_form_submit',
      form_submission: 'valid',
      formId: formId
    };

    if (hadField(formId)) {
      var data = readAndClear(formId);
      if ($.trim(data.selected_treatment) !== '') {
        payload.selected_treatment = data.selected_treatment;
      }
    }

    dataLayer.push(payload);
  });

$(document).on('gform_page_loaded', function(event, form_id, current_page){
	$('.quiz_start_page .gform_next_button').on('click', function (e) {

		var hcp_provider = $('input[name="input_1"]:checked').val();

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'start_energy_quiz',
			'quiz_type': hcp_provider
		});

	});
});
